import React from 'react';
import Translate from 'react-translate-component';
import cx from 'classnames';
import { Alert, Button } from 'antd';

export const Message = ({ error }) => (
    <Translate content={error.translate || error.message} fallback={error.message} unsafe />
);

const ErrorHTML = ({ meta: { error }, refresh, className }) => error ? (
    <div className={cx('alert alert-danger', className)}>
        <Alert message={<Message error={error} />} type="error" />
        { refresh && (
            <Button className="ant-btn-blue m-t-10" onClick={() => refresh()}>
                <Translate content="common.refresh" />
            </Button>
        )}
    </div>
) : null;

export default ErrorHTML;
